import Color from "color";

const Palette = {
  primary: {
    main: "#000000",
  },
  secondary: {
    main: "#ffffff",
  },
  error: {
    dark: Color("#f40000").darken(0.5).hex(),
    main: "#f40000",
  },
  warning: {
    main: "#f79900",
  },
  success: {
    dark: Color("#6ace7f").darken(0.5).hex(),
    main: "#6ace7f",
  },
  info: {
    dark: Color("#6ac9ce").darken(0.5).hex(),
    main: "#6ac9ce",
  },
};

export { Palette };
